fragment CompetitorForLeadFragment on Competitor {
    id
    name
    leadSuccessPercent
    reportUrl
}
